<label
  [attr.data-size]="size()"
  class="border-zinc-300 bg-gray-200"
  [class.active]="value()"
>
  <input
    type="checkbox"
    class="hidden"
    [(ngModel)]="value"
    (change)="handleChange($event)"
    [disabled]="disabled()!"
  />
  <div class="circle" [attr.data-size]="size()" [class.active]="value()"></div>
</label>
